import { H1, PrimaryButton } from "@itpi/react-components";
import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Page } from "../components/Page";
import AuthContext from "../context/AuthContext";
import TeacherLaughingWithStudents from "../assets/TeacherLaughingWithStudents.jpg";
import HelloSVG from "../assets/undraw_hello.svg";
import ContentSVG from "../assets/undraw_content.svg";
import SliderSVG from "../assets/undraw_slider.svg";
import TasksSVG from "../assets/undraw_tasks.svg";
import AnswerSVG from "../assets/undraw_answer.svg";
import EntrecompImage from "../assets/Entrecomp-image.jpg";
import DataSVG from "../assets/undraw_data.svg";
import ProjectionsSVG from "../assets/undraw_projections.svg";
import { Routes } from "../App";

export const LandingPage: React.FC<{}> = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          backgroundImage: `url(${TeacherLaughingWithStudents})`,

          backgroundPosition: "center center",
          backgroundSize: "cover",
          minHeight: "calc(100vh - 200px)",
          boxShadow: "0 4px 11px rgb(124 146 169 / 50%)",
          position: "relative",
        }}
      >
        <div
          style={{
            background: "linear-gradient(to right, #b5121b, #FF7372)",
            width: "100%",
            height: "100%",
            position: "absolute",
            opacity: 0.9,
          }}
        >
          <div
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              opacity: 1,
              textAlign: "center",
            }}
          >
            <h1 style={{ color: "white" }}>Welcome to ECHO</h1>
            <h2 style={{ color: "white" }}>
              Entrepreneurial Competencies Heutagogical Organiser
            </h2>
            <div>
              <Link to={Routes.NEW_ASSESSMENT}>
                <button
                  style={{
                    borderRadius: 50,
                    padding: 20,
                    fontSize: 20,
                    margin: 20,
                    color: "black",
                    backgroundColor: "#06d19c",
                    border: "none",
                  }}
                >
                  Take Assessment
                </button>
              </Link>
              <Link to={Routes.REPORTS}>
                <button
                  style={{
                    padding: 20,
                    fontSize: 20,
                    margin: 20,
                    color: "white",
                    background: "none",
                    border: "1px solid white",
                    borderRadius: 50,
                  }}
                >
                  View Reports
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "90px 30px",

          backgroundColor: "#eee",
          boxShadow: "0 2px 3px rgb(124 146 169 / 30%)",
        }}
      >
        <h2 style={{ marginBottom: 20 }}>How does this work?</h2>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <div style={{ padding: 20, maxWidth: 300, textAlign: "center" }}>
            <img style={{ maxHeight: 100 }} src={HelloSVG} alt="" />
            <h3>Step 1</h3>
            <p style={{ fontSize: 16 }}>
              Click the 'Take Assessment' button to open the self-assessment
              form
            </p>
          </div>
          <div style={{ padding: 20, maxWidth: 300, textAlign: "center" }}>
            <img style={{ maxHeight: 100 }} src={ContentSVG} alt="" />

            <h3>Step 2</h3>
            <p style={{ fontSize: 16 }}>
              Read the statements for each area to help you understand what it
              covers
            </p>
          </div>
          <div style={{ padding: 20, maxWidth: 300, textAlign: "center" }}>
            <img style={{ maxHeight: 100 }} src={SliderSVG} alt="" />

            <h3>Step 3</h3>
            <p style={{ fontSize: 16 }}>
              Think about your experience in each area and provide examples in
              the text box
            </p>
          </div>
          <div style={{ padding: 20, maxWidth: 300, textAlign: "center" }}>
            <img style={{ maxHeight: 100 }} src={TasksSVG} alt="" />

            <h3>Step 4</h3>
            <p style={{ fontSize: 16 }}>
              Based on your examples, use the slider to rate yourself from 1-8
              using the scale rubric
            </p>
          </div>
          <div style={{ padding: 20, maxWidth: 300, textAlign: "center" }}>
            <img style={{ maxHeight: 100 }} src={AnswerSVG} alt="" />

            <h3>Step 5</h3>
            <p style={{ fontSize: 16 }}>
              Submit your completed form to generate an instant visual report in
              your browser
            </p>
          </div>
        </div>
      </div>
      <div
        style={{
          padding: "90px 30px",
          boxShadow: "0 2px 3px rgb(124 146 169 / 30%)",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",

            alignItems: "center",
          }}
        >
          <img
            src={EntrecompImage}
            alt="Diagram listing the different components of the entre comp system"
            style={{ maxWidth: 450 }}
          />
          <h2 style={{ marginBottom: 20 }}>How do I rate myself?</h2>
          <p style={{ maxWidth: "80ch", fontSize: 16 }}>
            This is a self-assessment so your responses will be entirely
            subjective; it’s in your interest to be fair and honest. If this is
            your first assessment, take some time to consider the ‘I can…’
            statements under each of the 15 headings. The different dimensions
            of the competency area they reflect can be quite diverse and you may
            have experience of some and not others. Take this into account when
            thinking about your examples and your ratings.
          </p>
        </div>
      </div>
      <div
        style={{
          padding: "120px 30px",
          textAlign: "center",
          backgroundColor: "#eee",
          boxShadow: "0 2px 3px rgb(124 146 169 / 30%)",
          display: "flex",
          flexDirection: "column",

          alignItems: "center",
        }}
      >
        <p style={{ maxWidth: "80ch", fontSize: 16, marginBottom: 20 }}>
          Each score point on the slider also has a short rubric statement to
          help you position yourself accurately. The text, which changes as you
          move the slider, reflects the levels in the table below.
        </p>
        <table
          className="table"
          id="score"
          style={{ textAlign: "center", fontSize: 16 }}
        >
          <colgroup>
            <col span={2} style={{ backgroundColor: "#f8c1af" }} />
            <col span={2} style={{ backgroundColor: "#fee6c3" }} />
            <col span={2} style={{ backgroundColor: "#f3f7ba" }} />
            <col span={2} style={{ backgroundColor: "#DCFCE7" }} />
          </colgroup>
          <tbody>
            <tr style={{ fontWeight: 1000 }}>
              <th colSpan={2}>Foundation</th>
              <th colSpan={2}>Intermediate</th>
              <th colSpan={2}>Advanced</th>
              <th colSpan={2}>Expert</th>
            </tr>
            <tr>
              <td colSpan={2}>Relying on support from others</td>
              <td colSpan={2}>Building Independence</td>
              <td colSpan={2}>Taking Responsibility</td>
              <td colSpan={2}>
                Driving Transformation, Innovation &amp; Growth
              </td>
            </tr>
            <tr style={{ fontWeight: 900 }}>
              <td style={{ padding: 10 }}> 1</td>
              <td style={{ padding: 10 }}> 2</td>
              <td style={{ padding: 10 }}> 3</td>
              <td style={{ padding: 10 }}> 4</td>
              <td style={{ padding: 10 }}> 5</td>
              <td style={{ padding: 10 }}> 6</td>
              <td style={{ padding: 10 }}> 7</td>
              <td style={{ padding: 10 }}> 8</td>
            </tr>
            <tr style={{ fontWeight: 900 }}>
              <td style={{ padding: 10 }}>Discover</td>
              <td style={{ padding: 10 }}>Explore</td>
              <td style={{ padding: 10 }}>Experiment</td>
              <td style={{ padding: 10 }}>Dare</td>
              <td style={{ padding: 10 }}>Improve</td>
              <td style={{ padding: 10 }}>Reinforce</td>
              <td style={{ padding: 10 }}>Expand</td>
              <td style={{ padding: 10 }}>Transform</td>
            </tr>

            <tr>
              <td colSpan={8} style={{ backgroundColor: "#fff" }}>
                i.e. I can do this...
              </td>
            </tr>
            <tr>
              <td>...under direct supervision.</td>
              <td>
                ...with reduced support from others, some autonomy, and together
                with my peers.
              </td>
              <td>...on my own and together with my peers.</td>
              <td>...taking and sharing some responsibilities.</td>
              <td>...with some guidance and together with others.</td>
              <td>
                ...taking responsibility for making decisions and working with
                others.
              </td>
              <td>
                ...taking responsibility for contributing to complex
                developments in a specific field.
              </td>
              <td>
                ...contributing substantially to the development of a specific
                field.
              </td>
            </tr>
          </tbody>
        </table>

        <p style={{ maxWidth: "80ch", fontSize: 16, marginTop: 20 }}>
          If you think it would be helpful to see more detail about each of the
          competencies and levels as you complete your assessment, you can refer
          to the full framework contained in the appendix to the {" "}
          <a style={{color: "darkred"}} href="https://eur02.safelinks.protection.outlook.com/?url=https://publications.jrc.ec.europa.eu/repository/bitstream/JRC101581/lfna27939enn.pdf&data=04%7c01%7cjosh.stennett%40lancaster.ac.uk%7cc158755d1f5b4457845208d972d5c695%7c9c9bcd11977a4e9ca9a0bc734090164a%7c0%7c0%7c637667084741850135%7cUnknown%7cTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7c1000&sdata=RISlbSzrqPLRndTuAX%2BQiJsa1rHyDz64XKk/I6HMG%2BY%3D&reserved=0">
              original publication here
          </a>{" "}
          (pp25-37).
        </p>
      </div>

      <div
        style={{
          padding: "90px 30px",
          boxShadow: "0 2px 3px rgb(124 146 169 / 30%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img alt="" src={ProjectionsSVG} style={{ maxWidth: 220 }} />
        <h2 style={{ margin: 20 }}>How do I see my results?</h2>
        <p style={{ maxWidth: "80ch", fontSize: 16 }}>
          Once you submit your completed form, you will be presented with a
          report featuring a radar chart, which provides an easy visual overview
          of your self-assessed strengths and weaknesses. Your narrative
          responses will be presented alongside this. You can view your reports
          at any time via the View Reports button above.
        </p>
        <p style={{ maxWidth: "80ch", fontSize: 16 }}>
          Please note that every time you launch a new test, you will find your
          responses from the last report presented to you in the survey fields.
          This is just to help you to build on these and ensure continuity
          through your responses over time. Please bear in mind that as soon as
          you touch the slider or input into the text box, these responses will
          disappear, so it's worth scanning these before you start.
        </p>
      </div>
      <div
        style={{
          padding: "90px 30px",
          boxShadow: "0 2px 3px rgb(124 146 169 / 30%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img src={DataSVG} alt="" style={{ maxWidth: 220 }} />
        <h2 style={{ margin: 20 }}>Acknowledgements</h2>
        <p style={{ maxWidth: "80ch", fontSize: 16 }}>
          ECHO is being developed for Work in Progress by graduate developers
          from Lancaster University's{" "}
          <a href="https://www.lancaster.ac.uk/itpi/">
            ISS Innovation &amp; Partnering Team
          </a>
          . It is currently being implemented as an MVP (Minimum Viable Product)
          to establish the basic functionality and seek user feedback before
          more sophisticated user functionality is added. For this reason, you
          may find some user experience issues that we'd like to hear about
          ready for the next stages of development. Email them to{" "}
          <a href="mailto:s.harrison4@lancaster.ac.uk">
            s.harrison4@lancaster.ac.uk
          </a>
        </p>

        <p style={{ maxWidth: "80ch", fontSize: 16 }}>
          ECHO has been made possible thanks to the generous support of
          Lancaster University alumni who have made donations directly in
          support of student innovation and entrepreneurial development.
        </p>
      </div>
      <div
        style={{
          background: "linear-gradient(to left, #b5121b, #FF7372)",
          padding: "90px 30px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h2 style={{ color: "white" }}>Get started now</h2>

        <Link to={Routes.NEW_ASSESSMENT}>
          <button
            style={{
              borderRadius: 50,
              padding: 20,
              fontSize: 20,
              margin: 20,
              color: "black",
              backgroundColor: "#06d19c",
              border: "none",
            }}
          >
            Take Assessment
          </button>
        </Link>
      </div>
    </div>
  );
};

export default LandingPage;
